'use client'

import { Skeleton } from '@/components/skeleton'
import { RestaurantDetailVisualsContainer } from '@/features/restaurants/restaurant-detail/restaurant-detail-images/restaurant-detail-images-container'
import { range } from '@/utils/functions/range'

/** Mirrors the detail page: header block, gallery row, tab bar, sections */
export const RestaurantDetailSkeleton = () => {
    return (
        <div className="flex flex-col items-center w-full min-h-dvh">
            <div className="restaurant-detail-inner-container mt-4 md:mt-8">
                {/* Breadcrumbs, name, meta line */}
                <Skeleton className="h-5 w-56 max-w-full mb-2 md:mb-3" />
                <Skeleton className="h-9 md:h-11 w-72 md:w-[420px] max-w-full" />
                <Skeleton className="h-5 w-80 max-w-full mt-2 md:mt-3" />

                {/* Mobile CTAs */}
                <div className="mt-3 flex gap-x-2 md:hidden">
                    <Skeleton className="h-[42px] w-36 rounded-l" />
                    <Skeleton className="h-[42px] w-24 rounded-l" />
                </div>
            </div>

            <RestaurantDetailVisualsContainer visuals={null} className="mt-4 md:mt-8" />

            {/* Tab bar */}
            <div className="restaurant-detail-inner-container mt-4 md:mt-8">
                <div className="flex items-center gap-x-8 border-b border-b-border-primary pb-4">
                    {range(4).map((_, index) => (
                        <Skeleton
                            key={'restaurant-detail-skeleton-tab' + index}
                            className="h-5 w-20"
                        />
                    ))}
                </div>
            </div>

            <div className="restaurant-detail-inner-container mt-8 md:mt-12">
                <Skeleton className="w-full min-h-40 md:min-h-[200px] mb-8 md:mb-14" />
                <Skeleton className="w-full min-h-40 md:min-h-[200px]" />
            </div>
        </div>
    )
}
